import React, { createContext, useMemo, useState } from 'react'
import { ModalProvider, light, dark } from '@pancakeswap/uikit'
import { Web3ReactProvider } from '@web3-react/core'
import { HelmetProvider } from 'react-helmet-async'
import { Provider } from 'react-redux'
import { ThemeProvider } from 'styled-components'
import { useThemeManager } from 'state/user/hooks'
import { getLibrary } from 'utils/web3React'
import { LanguageProvider } from 'contexts/Localization'
import { RefreshContextProvider } from 'contexts/RefreshContext'
import { ToastsProvider } from 'contexts/ToastsContext'
import store from 'state'

export interface ArcadeGameProps {
  imgSrc: string
  title: string
  gameSrc: string
}

export const ArcadeContext = createContext({
  currentGame: null,
  setCurrentGame: null as React.Dispatch<React.SetStateAction<ArcadeGameProps>>,
})

export const MerchRegionContext = createContext({
  region: null,
  setRegion: null as React.Dispatch<React.SetStateAction<string>>,
})

const ThemeProviderWrapper = (props) => {
  const [isDark] = useThemeManager()
  return <ThemeProvider theme={isDark ? dark : light} {...props} />
}

const Providers: React.FC = ({ children }) => {
  const [currentGame, setCurrentGame] = useState<ArcadeGameProps>(null)
  const [region, setRegion] = useState<string>(null)
  const value = useMemo(() => ({ currentGame, setCurrentGame }), [currentGame])
  const regionValue = useMemo(() => ({ region, setRegion }), [region])

  return (
    <Web3ReactProvider getLibrary={getLibrary}>
      <ArcadeContext.Provider value={value}>
        <MerchRegionContext.Provider value={regionValue}>
          <Provider store={store}>
            <ToastsProvider>
              <HelmetProvider>
                <ThemeProviderWrapper>
                  <LanguageProvider>
                    <RefreshContextProvider>
                      <ModalProvider>{children}</ModalProvider>
                    </RefreshContextProvider>
                  </LanguageProvider>
                </ThemeProviderWrapper>
              </HelmetProvider>
            </ToastsProvider>
          </Provider>
        </MerchRegionContext.Provider>
      </ArcadeContext.Provider>
    </Web3ReactProvider>
  )
}

export default Providers
